/**
 * WebSocket URL utility functions
 *
 * Provides consistent WebSocket URL construction across the application
 * to ensure proper absolute URL generation for all environments.
 */

/**
 * Constructs an absolute WebSocket URL from a relative path
 *
 * @param relativePath - The relative WebSocket path (e.g., "/api/user_jobs/status/")
 * @returns The absolute WebSocket URL (e.g., "wss://talent.performyard.com/api/user_jobs/status/")
 */
export const buildWebSocketUrl = (relativePath: string): string => {
	const protocol = window.location.protocol === "https:" ? "wss:" : "ws:";
	const host = window.location.host;
	return `${protocol}//${host}${relativePath}`;
};

/**
 * Creates a WebSocket connection with proper URL construction
 *
 * @param relativePath - The relative WebSocket path
 * @returns A new WebSocket instance with absolute URL
 */
export const createWebSocket = (relativePath: string): WebSocket => {
	const absoluteUrl = buildWebSocketUrl(relativePath);
	return new WebSocket(absoluteUrl);
};
